export default __webpack_public_path__ + "static/media/refer_charity.ad86b582.svg";